import type { TextI, TickerI } from "tweenly"
import { PayloadAction } from "@reduxjs/toolkit"
import { updateObjectStyle } from "../../../../helpers/object.helpers"
import { ObjectsStateT } from "../../objects.slice"

export type UpdateTickerTextsStylePayload = {
    object: TickerI
    maskObject: TickerI
    textObjects: TextI[]
    property: any
    value: any
}

export const updateTickerTextsStyleWithoutRestartBaseAction = (
    state: ObjectsStateT,
    action: PayloadAction<UpdateTickerTextsStylePayload>
) => {
    const { textObjects, property, value } = action.payload

    // Aktualizovat styly všech textů bez nastavení updatedAt
    const actualStateValue = { ...state.value }
    textObjects.forEach((textObject: TextI) => {
        actualStateValue[textObject.id] = {
            ...state.value[textObject.id],
            styles:
                updateObjectStyle(textObject, property, value) ??
                state.value[textObject.id]?.styles,
        }
    })
    state.value = actualStateValue

    // DŮLEŽITÉ: NENASTAVUJEME updatedAt
    // To zajistí, že se ticker nebude restartovat při změnách jako color, opacity, atd.
}
